import React, {useEffect, useState} from "react";
import {createConnection} from "../../services/fetch";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import Sujet from "./sujet";
import Sket from "../sket";
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/css';
import {useDom} from "../../context/dom";

export default function Story(props) {
  const { id } = useParams();
  const { sujetId } = useParams();
  const { mname } = useParams();
  const { sstory } = useParams();
  const [page, setPage] = useState(null);
  const [stories, setStories] = useState(null);
  const [su, setSu] = useState(null);
  const navigate = useNavigate();
  const ww=props.w<480   ? Math.floor(window.outerWidth) : Math.floor(window.outerWidth/2);
  const hh=props.w<480   ? '100vh' : '200px';
  const location = useLocation();

const dom=useDom()

    const story = sstory == 'ttemp' ? 'GoogleKeep' : sstory;
  useEffect(() => {
const uId=window.uId;

      su && setSu(null);
    if(!page && story && !id  && (!uId || uId=='') )   {

      !story.match(/^([\d]+)$/)   &&  createConnection().getNew('story','join=sujet&exclude=sujet.code&filter=name,eq,'+story).then(a=> {
    document.getElementById('ttid').id="d";

          a.records[0].sujet.map(p=>{

            (sujetId && p.name==sujetId ) && setSu(p.id);
            (mname && p.name==mname ) && setSu(p.id);

          }).sort((a,b)=>a.id-b.id)
const st = a.records[0];
        st.sujet =   st.sujet.filter(f=>f.thumb ? f : null)
          setPage(st);
        }
      );

    }

  //
console.log('Location changed!', location.pathname, page,story,su);
    (location.pathname == '/stories' && page ) && setPage(null);
    if(!page && props.st && props.st.sujet.length>0)   {

      createConnection().getNew('sujet/'+props.st.sujet[0].id,'').then(a=> {
          setPage(a);

        }
      );

    }
    if(!page && (id || props.sto))   {
     // document.getElementById('ttid').id="d";
        if( document.getElementById('ttid') && props.sto)document.getElementById('ttid').id="d";
const iid=props.sto ? props.sto : id;
      iid.match(/^([\d]+)$/)  &&    createConnection().getNew('story/'+iid,'join=sujet&include=name,description,sujet.name,sujet.id,sujet.thumb').then(a=> {

setPage(a);
        }
      );

      !iid.match(/^([\d]+)$/)  &&    createConnection().getNew('story','order=id,desc&join=sujet&exclude=sujet.code&filter=name,eq,'+iid).then(a=> {

          a.records[0].sujet.map(p=>{

          (sujetId && p.name==sujetId ) && setSu(p.id);
          (mname && p.name==mname ) && setSu(p.id);

        }).sort((a,b)=>a.id-b.id)

        setPage(a.records[0]);
        }
      );



    }

    if(sujetId && story && !su)   {

     story.length>2  &&    createConnection().getNew('story','filter=name,eq,'+story+'&join=sujet&include=name,description,sujet.name,sujet.id,sujet.thumb').then(a=> {


         a.records[0].sujet.map(p=>{

         (sujetId && p.name==sujetId ) && setSu(p.id);
         (mname && p.name==mname ) && setSu(p.id);


       }).sort((a,b)=>a.id-b.id);
          //setPage(a.records[0]);
        }
      );

    }
    if(!id && !story && !props.st){
if(!stories){
      createConnection().getNew('story','filter=user,eq,11&join=sujet&exclude=sujet.code').then(a=> {
        const strs=a.records.map(y=>{
          let thumb;
          y.sujet.map(t=>{t.thumb ? thumb=t.thumb : thumb = thumb; return t;});
          y.thumb=thumb;
          return y;

        });
        setStories(strs)

      })

    }
  }

  },[location]);
  return  props.st ?
        (
            <div className="flex flex-col bg-gray-500 text-white" style={{height:'100vh'}}>

<div className="flex-grow justify-between items-center p-4">
          <div  style={{width:'100%',height:'100%', backgroundPosition:'center',backgroundRepeat:'no-repeat', backgroundSize:'contain',backgroundImage: page? 'url('+page.thumb+')' : 'none'}}
               onClick={()=>navigate('/'+props.st.name)}>
          </div>
            </div>       <div className="text-center p-4"> {props.st.name}<br/>
              <small> {props.st.description}</small>
            </div>
          </div>
        )
        :
        (
         <div style={{position:'relative'}}>

           {(page && !mname && !sujetId) ? (
             <>


               <Swiper
                 spaceBetween={0}
                 history={ {replaceState: true,watchState:true} }
                 hashNavigation={ {replaceState: true,watchState:true} }
                 slidesPerView={1}
                 loop={true}
                 initialSlide={dom.reg}
                 onSlideChange={(e) => dom.setReg(e.activeIndex)}
                 onSwiper={(swiper) => console.log(swiper)}
               >


                 {page.sujet.sort((a,b)=>b.id-a.id).map((a,i)=>
                   (

                     <SwiperSlide key={a.id} >
                     <Sujet  st={a} story={page.name}/>
                     </SwiperSlide>

                   )
                 )


                 }

               </Swiper>



             </>
           ) : (

            <>
              {su && (


                  <Sket story_id={su} page={page} />

              )}


</>
           )}
         </div>
        )


}
